import { makeStyles } from "@material-ui/core/styles";
import { secondary, black } from "../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  icon: {
    width: theme.spacing(2),
    color: ({ disabled }) => (disabled ? black : secondary),
  },
}));

export default useStyles;
